import Swiper, { EffectFade, Thumbs, Autoplay, Navigation } from "swiper";

function initSwiper() {
  if (typeof Swiper === "undefined") {
    return false;
  }

  const homeFeaturesSlider = new Swiper(".hero-home__navigation", {
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 4,
        direction: "vertical",
      },
    },
    watchSlidesProgress: true,
  });

  const homeHeadingsSlider = new Swiper(".hero-home__carousel", {
    modules: [EffectFade, Thumbs, Autoplay, Navigation],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: homeFeaturesSlider,
    },
    autoplay: {
      delay: 10000,
    },
    navigation: {
      nextEl: ".hero-home__aside .next",
      prevEl: ".hero-home__aside .prev",
    },
    preloadImages: true,
  });

  homeFeaturesSlider.on("slideChange", function () {
    const currentSlide = homeFeaturesSlider.slides[homeFeaturesSlider.activeIndex].dataset.index;
    homeHeadingsSlider.slideTo(currentSlide, 500, true);
  });

  homeFeaturesSlider.on("tap", function () {
    const currentSlide = homeFeaturesSlider.clickedIndex;
    homeHeadingsSlider.slideTo(currentSlide, 500, true);
  });

  homeHeadingsSlider.on("slideChange", function () {
    const currentSlide = homeHeadingsSlider.slides[homeHeadingsSlider.activeIndex].dataset.index;
    homeFeaturesSlider.slideTo(currentSlide, 500, true);

    const swiperVideos = document.querySelectorAll(".hero-home__carousel video");
    swiperVideos.forEach(function (e) {
      e.play();
    });
  });

  homeHeadingsSlider.on("tap", function () {
    const currentSlide = homeHeadingsSlider.clickedIndex;
    homeFeaturesSlider.slideTo(currentSlide, 500, true);
  });

  return true;
}

document.addEventListener("DOMContentLoaded", () => {
  const checkSwiperLoaded = setInterval(() => {
    if (initSwiper()) {
      clearInterval(checkSwiperLoaded);
    }
  }, 100);
});
